import { getToken } from "../authorization/auth";
import { API_ENDPOINT } from "../authorization/const";


export async function decodeRef(ref) {
    if (ref === "C") return "Cash Note";
    if (ref === "I") return "Invoice";
    if (ref === "P") return "Pickup";
    if (ref === "Q") return "Packaging";
    if (ref === "D") return "Day Booking";
    if (ref === "V") return "Vendor";
    if (ref === "S") return "Salary Payment";
    if (ref === "L") return "Loss";
    if (ref === "E") return "Employee Other Payment";
    return "";
}
export async function getAccountsList() {
    const res = await fetch(API_ENDPOINT + "accounts/get-all/" + getToken());
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function getTransactions() {
    const res = await fetch(API_ENDPOINT + "transaction/get-all/" + getToken());
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function getAccountTransactions(account, page) {
    const res = await fetch(API_ENDPOINT + "transaction/get/" + account + "/" + getToken() + "?page=" + page);
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function adjustAccounts() {
    const res = await fetch(API_ENDPOINT + "accounts/adjust/" + getToken(), { method: "PATCH" });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function getAccountType() {
    const res = await fetch(API_ENDPOINT + "admin/get-account-type");
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export async function newAccount(data) {
    data["auth"] = getToken();
    const res = await fetch(API_ENDPOINT + "accounts/create", {
        method: "POST",
        body: JSON.stringify(data)
    });
    if (res.status === 200)
        return await res.json();
    throw await res.json();
}

export function makeJournalEntry(transaction_items, balance, opening_date, account, lagecy) {
    if (transaction_items.length === 0) {
        return [{ vhr_date: opening_date, description: "Opening balance", debit_amt: 0, credit_amt: 0, balance: balance }];
    } else if (lagecy) {
        transaction_items.slice().forEach(itm => {
            itm.balance = balance;
            if (itm.debit === account) {
                balance = balance + itm.amount;
                itm.debit_amt = itm.amount;
                itm.credit_amt = 0;
            } else {
                balance = balance - itm.amount;
                itm.debit_amt = 0;
                itm.credit_amt = itm.amount;
            }
        });
        return transaction_items;
    } else {
        const ob = balance;
        transaction_items.slice().reverse().forEach(itm => {
            if (itm.debit === account) {
                balance = balance - itm.amount;
                itm.debit_amt = itm.amount;
                itm.credit_amt = 0;
            } else {
                balance = balance + itm.amount;
                itm.debit_amt = 0;
                itm.credit_amt = itm.amount;
            }
            itm.balance = balance;
        });
        transaction_items.push({ vhr_date: opening_date, description: "Opening balance", debit_amt: 0, credit_amt: 0, balance: ob });
        console.log("After audit current balance: " + balance.toFixed(2));
        return transaction_items;
    }
}
